import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.grey)}
            d="M77.973,60.82a4.59,4.59,0,1,1-4.561,4.59A4.576,4.576,0,0,1,77.973,60.82Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M47.8,29.669h7.68a1.042,1.042,0,0,1,1.042,1.042v1.121a1.042,1.042,0,0,1-1.042,1.042H47.8a0,0,0,0,1,0,0V29.669A0,0,0,0,1,47.8,29.669Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M26.526,29.615h6.335a1.6,1.6,0,0,1,1.6,1.6v0a1.6,1.6,0,0,1-1.6,1.6H26.526a.785.785,0,0,1-.785-.785V30.4a.785.785,0,0,1,.785-.785Z"
          />
          <path
            className={css(styles.action)}
            d="M49.967,32.781a.928.928,0,0,0,.534-.838V30.569a.936.936,0,0,0-.935-.936H42.134a.932.932,0,0,0-.7.321l-1.155,1.325a.935.935,0,0,0,.4,1.5H29a1.609,1.609,0,0,0-.108-3.214H22.526a.79.79,0,0,0-.789.79V32a.784.784,0,0,0,.735.779h-9.51a.934.934,0,0,0-.933.934V62.566a.935.935,0,0,0,.524.84l5.457,2.665a5.339,5.339,0,0,0,2.338.54h1.53c-.011-.144-.022-.287-.022-.433a5.878,5.878,0,1,1,11.755,0c0,.146-.012.289-.022.433h16.9c-.011-.144-.022-.287-.022-.433a5.878,5.878,0,1,1,11.755,0c0,.146-.012.289-.022.433h4.885l.928-33.83ZM32.9,46.244A1.861,1.861,0,0,1,31.04,48.1H20.911a1.861,1.861,0,0,1-1.855-1.855V41.318a1.861,1.861,0,0,1,1.855-1.855H31.04A1.861,1.861,0,0,1,32.9,41.318Zm28.3,5.288h-8.2a1.112,1.112,0,0,1-1.112-1.113V37.633a1.112,1.112,0,0,1,1.112-1.113h7.055a1.108,1.108,0,0,1,1.105.977c.494,4.138.966,10.281,1.154,12.844A1.11,1.11,0,0,1,61.2,51.532Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M88.405,59.486H85.974a.934.934,0,0,1-.931-.931v-.206a.934.934,0,0,1,.931-.931h2.291C87.814,52.2,86.485,44.974,84.9,37.07a5.391,5.391,0,0,0-5.293-4.291l-16.793-.032a178.235,178.235,0,0,1,2.207,23.6h-18.2V44.168A1.634,1.634,0,0,0,45.2,42.54H38.629A1.634,1.634,0,0,0,37,44.168V56.343H12.02v6.2a.935.935,0,0,0,.524.839L18,66.042a5.336,5.336,0,0,0,2.338.54h1.53c-.011-.144-.022-.287-.022-.433a5.878,5.878,0,0,1,11.755,0c0,.146-.012.289-.022.433h16.9c-.011-.144-.022-.287-.022-.433a5.878,5.878,0,0,1,11.755,0c0,.146-.012.289-.022.433h1.926c.067,0,13.841.256,21.585-.6a2.843,2.843,0,0,0,2.455-2.157A16.6,16.6,0,0,0,88.405,59.486Zm-43.091-9.5A1.414,1.414,0,0,1,43.9,51.4H40.024a1.414,1.414,0,0,1-1.411-1.41V45.669a1.415,1.415,0,0,1,1.411-1.411H43.9a1.415,1.415,0,0,1,1.411,1.411Zm27.831,8.8a.934.934,0,0,1-.932.931H68.7a.934.934,0,0,1-.931-.931v-.206a.934.934,0,0,1,.931-.931h3.511a.934.934,0,0,1,.932.931Z"
          />
          <path
            className={css(styles.grey)}
            d="M29.911,66.134a2.192,2.192,0,1,0-2.192,2.207A2.2,2.2,0,0,0,29.911,66.134Zm2.553,0a4.745,4.745,0,1,1-4.745-4.775A4.76,4.76,0,0,1,32.464,66.134Z"
          />
          <path
            className={css(styles.grey)}
            d="M58.557,66.134a2.192,2.192,0,1,0-2.192,2.207A2.2,2.2,0,0,0,58.557,66.134Zm2.553,0a4.745,4.745,0,1,1-4.745-4.775A4.76,4.76,0,0,1,61.11,66.134Z"
          />
          <rect className={css(styles.action)} x="74.32" y="57.766" width="9.364" height="1.383" rx="0.691" />
          <rect className={css(styles.action)} x="74.32" y="59.955" width="9.364" height="1.383" rx="0.691" />
          <path
            className={css(styles.grey)}
            d="M64.877,51.645H87.569c-.085-1.615-1.876-11.665-2.728-15.1H63.36S64.573,48.7,64.877,51.645Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="68.2"
            y="43.458"
            width="16.929"
            height="0.9"
            rx="0.45"
            transform="translate(111.263 -37.384) rotate(83.254)"
          />
          <path
            className={css(styles.action)}
            d="M14.771,67.24a1.625,1.625,0,0,1,1.215-1.712c1.056-.282,1.6.946,2.428.869.684-.062.806-.807,1.275-1.318a2.642,2.642,0,0,1,2.726-.767c1.846.849.524,2.9,1.625,3.251.455.145,1.19-.343,1.57-.667a2.624,2.624,0,0,1,2.369-.551c1.68.414.8,2.121,1.983,2.727.579.3.936-.633,2.032-.161a1.5,1.5,0,0,1,.586,1.85c-5.51.046-14.591.12-20.238.074,0,0-1.026-1.561.187-2.188.91-.47,1.271.391,1.966.054C15.107,68.405,14.777,67.652,14.771,67.24Z"
          />
        </g>
      </svg>
    );
  }
}
